import Super from './-resources';
import classic from 'ember-classic-decorator';

@classic
export default class SiteBillingIndex extends Super {}
